// extracted by mini-css-extract-plugin
export var RecruitHeroImage = "RecruitHeroImage-module--RecruitHeroImage--1v91k";
export var RecruitHeroImage__title = "RecruitHeroImage-module--RecruitHeroImage__title--3WQXc";